import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Overlay, Popover, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Formik, Form } from "formik";
import FormikControl from "../../../layouts/Input/FormikControl";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import { renderCell, renderHeader, toCommaSeparated } from "../../../utilities/FUNCTIONS";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_LENDER_DDL,
} from "../../../Types";

import {
  getLoanRepaymentReport,
  downloadJob,
} from "./LoanRepaymentReportActions";

import storage from "../../../apis/Storage";
import { isPermittedPage } from "../../../apis/Utility";
import { formatDate } from "../../../utilities/FUNCTIONS";
import ApplyLoanRepaymentForm from "./RepamentAdjutments/ApplyLoanRepaymentForm";

const LoanRepaymentReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  //Pagination
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const [showPaymentAdjustementPopup, setShowPaymentAdjustementPopup] = useState(false);

  const [filter, setfilter] = useState({
    distributorId: [],
    distCenterId: [],
    vizId: null,
    financier: [],
    kycStatus: null,
    contractStatus: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
    isExport: false,
  });

  const [lenderOptions, setLenderOptions] = useState([]);

  const [addJobDistributorsOptions, setAddJobDistributorsOptions] =
    useState(null);
  const [addJobDistCenterOptions, setAddJobDistCenterOptions] = useState([]);

  const columns = [
    {
      Header: "VIZ ID",
      accessor: "vizShopCode",
    },
    {
      Header: "Invoice Number",
      accessor: "invoiceNumber",
    },
    {
      Header: "Loan Id",
      accessor: "loanId",
    },
    {
      Header: "Financier",
      accessor: "financier",
    },
    {
      Header: "Paid Through",
      accessor: "paidThrough",
    },
    {
      Header: "Finance Status",
      accessor: "financeStatus",
    },
    {
      Header: renderHeader("Invoice Amount"),
      accessor: "invoiceAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Finance Amount"),
      accessor: "financeAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Repaid Amount"),
      accessor: "repaidAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Outstanding Amount"),
      accessor: "outstandingAmount",
      Cell: ({ value }) => renderCell(value, true),
    },

  ];

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setAddJobDistCenterOptions([]);
    setfilter({
      distributorId:
        userRights != null && userRights?.userType == "DistributorUser"
          ? toCommaSeparated(filter.distributorId)
          : [],
      distCenterId: toCommaSeparated(filter.distCenterId),
      vizId: '',
      financier: toCommaSeparated(filter.financier),
      kycStatus: null,
      contractStatus: null,
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: null,
      isExport: false,
    });
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageSize: pageSize };
    fetchReportData(request);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
  };

  const Download = () => {
    let request = formRequestObject(true);
    props.downloadJob(request);
  };

  function formRequestObject(isExport = false) {
    let requestData = {
      distributorId: toCommaSeparated(filter.distributorId),
      distCenterId: toCommaSeparated(filter.distCenterId),
      vizId: filter.vizId,
      financier: toCommaSeparated(filter.financier),
      kycStatus: filter.kycStatus?.value,
      contractStatus: filter.contractStatus?.value,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
      isExport: isExport,
    };
    if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
      requestData = {
        ...requestData,
        distributorId: toCommaSeparated(userRights?.distributorId),
      };
    }
    return requestData;
  }

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.getLoanRepaymentReport(finalRequest);
  }

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData();
  }, [searchText]);

  useEffect(() => {
    if (props.LoanRepaymentReportdata) {
      setTotalRecords(props.LoanRepaymentReportdata?.totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.LoanRepaymentReportdata]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  useEffect(() => {
    props.getDropdownList(`api/Lender/GetLendersDDL`, GET_LENDER_DDL);
  }, []);

  useEffect(() => {
    setLenderOptions(
      props.allLenderList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.allLenderList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId
      );
      setAddJobDistributorsOptions(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorList = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value)
      );
      setAddJobDistributorsOptions(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setAddJobDistributorsOptions(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
      var assignedDistcenterIds = userRights.distCenterIds.split(",");
      let filteredItems = props.addJobDistCentersddlList.filter((item) =>
        assignedDistcenterIds.includes(item.value)
      );
      setAddJobDistCenterOptions(
        filteredItems.map(function (item) {
          return {
            value: item.value,
            label: item.label,
            principalName: item.principalName,
            cityName: item.cityName,
          };
        })
      );
    } else {
      setAddJobDistCenterOptions(
        props.addJobDistCentersddlList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.addJobDistCentersddlList]);

  useEffect(() => {
    if (!filter.distributorId || filter.distributorId.length > 0) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: toCommaSeparated(filter.distributorId) },
        GET_DISTRIBUTIONCENTER_DDL
      );
    }
    filter.distCenterId = [];
  }, [filter.distributorId]);

  const kycStatusOptions = [
    {
      label: "Pending",
      value: 1,
    },
    {
      label: "UnPaid",
      value: 2,
    },
    {
      label: "Paid",
      value: 3,
    },
    {
      label: "Error",
      value: 4,
    },
  ];

  const contractStatusOptions = [
    {
      label: "Jazzcash",
      value: "Jazzcash ",
    },
    {
      label: "Easypaisa",
      value: "Easypaisa",
    },
  ];

  return (
    <div>
      <VzPageContainer title="Loan Repayment Report">

        <Row className="mb-3">
          <Col>
            <h4>
              <b>Loan Repayment Report</b>
            </h4>
          </Col>
        </Row>

        <Row className="align-items-center mb-3">

          {/* Left: Filters */}
          <Col md={6}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={{}}
                      validator={() => ({})}
                      onSubmit={(e) => LoadDataByfilter(e)}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Col xs={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor"
                                name="distributorName"
                                options={addJobDistributorsOptions}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    distributorId: e || [],
                                    distCenterId: [],
                                  });
                                }}
                                value={filter.distributorId}
                              />
                            </Col>

                            <Col xs={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distCenterId"
                                options={addJobDistCenterOptions}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    distCenterId: e || [],
                                  });
                                }}
                                value={filter.distCenterId}
                              />
                            </Col>

                            <Col xs={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Viz ID"
                                name="vizId"
                                handleOnChange={(e) =>
                                  setfilter({ ...filter, vizId: e })
                                }
                                value={filter.vizId}
                              />
                            </Col>

                            <Col xs={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Financier"
                                name="financier"
                                options={lenderOptions}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    financier: e || [],
                                  });
                                }}
                                value={filter.financier}
                              />
                            </Col>

                            <Col xs={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Finance Status"
                                name="status"
                                options={kycStatusOptions}
                                isSearchable
                                handleOnChange={(e) => {
                                  if (!e?.value) return;
                                  setfilter({
                                    ...filter,
                                    kycStatus: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.kycStatus}
                              />
                            </Col>

                            <Col xs={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Paid Through"
                                name="status"
                                options={contractStatusOptions}
                                isSearchable
                                handleOnChange={(e) => {
                                  if (!e?.value) return;
                                  setfilter({
                                    ...filter,
                                    contractStatus: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.contractStatus}
                              />
                            </Col>

                            <Col xs={12} md={6}>
                              <FormikControl
                                control="date"
                                label="From Date"
                                name="fromDate"
                                handleOnChange={(value) =>
                                  setfilter({ ...filter, fromDate: value })
                                }
                                value={filter.fromDate}
                              />
                            </Col>

                            <Col xs={12} md={6}>
                              <FormikControl
                                control="date"
                                label="To Date"
                                name="toDate"
                                handleOnChange={(value) =>
                                  setfilter({ ...filter, toDate: value })
                                }
                                value={filter.toDate}
                              />
                            </Col>
                          </Row>

                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>

          {/* Right: Action Buttons */}
          <Col md={6} className="d-flex justify-content-end gap-2">
            {isPermittedPage("ApplyNew", props.actions, props.userRole) && (
              <Button
                onClick={() => setShowPaymentAdjustementPopup(true)}
                variant="outline-primary"
              >
                <i className="fa fa-plus me-1" />
                Apply New
              </Button>
            )}

            {isPermittedPage("Export", props.actions, props.userRole) && (
              <Button
                onClick={Download}
                variant="outline-primary"
              >
                <i className="fa fa-download me-1" />
                Export
              </Button>
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <ServerSideDataTable
              data={props.LoanRepaymentReportdata?.report ?? []}
              columns={columns}
              goToPreviousPage={getData}
              goToNextPage={getData}
              totalRecords={totalRecords}
              pageSizeChange={pageSizeChanged}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>

        <Modal
          show={showPaymentAdjustementPopup}
          onHide={() => setShowPaymentAdjustementPopup(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>JazzCash Failed Repayment Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ApplyLoanRepaymentForm
              onClose={() => setShowPaymentAdjustementPopup(false)}
            />
          </Modal.Body>
        </Modal>

      </VzPageContainer>
    </div>
  );

};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],

    addJobDistCentersddlList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    allLenderList: state.ddlList.lenderList ? state.ddlList.lenderList : [],
    LoanRepaymentReportdata: state.LoanRepaymentReportdata,
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  getLoanRepaymentReport,
  downloadJob,
})(LoanRepaymentReport);
